define("shared/utils/platform-check", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.isIos = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  const isIos = navigator => {
    return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) || /iPad|iPhone|iPod/.test(navigator.userAgent);
  };

  _exports.isIos = isIos;
});